import * as React from 'react';
import { IconProps } from '../types';

const IcCashierSave = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M5.374 3h12.248c.138.015.266.08.361.18 1.111 1.112 2.224 2.223 3.334 3.335a.637.637 0 0 1 .183.332v12.28a1.958 1.958 0 0 1-.699 1.421A1.958 1.958 0 0 1 19.63 21H5.373A1.955 1.955 0 0 1 3.5 19.128V4.84c.03-.449.208-.89.518-1.218A1.957 1.957 0 0 1 5.374 3Zm-.819 1.932v14.135a.888.888 0 0 0 .843.876c.497.005.994 0 1.49.002.003-1.816-.002-3.632.003-5.447.007-.77.525-1.5 1.247-1.766.38-.16.799-.128 1.201-.13h6.5c.335-.005.68-.005.999.12.733.26 1.264.997 1.27 1.777.006 1.815.001 3.63.003 5.446.497-.001.994.003 1.491-.002a.888.888 0 0 0 .843-.877c0-3.974.002-7.947-.002-11.921-.17-.2-.372-.375-.553-.566l-2.39-2.39c-.047-.044-.087-.1-.143-.133a5.396 5.396 0 0 0-.378.002c.005 1.417.002 2.833.002 4.25a1.94 1.94 0 0 1-1.947 1.959c-2.065.002-4.128.002-6.192 0A1.945 1.945 0 0 1 6.89 8.31c-.002-1.418 0-2.836-.001-4.254-.497 0-.995-.003-1.491.002a.888.888 0 0 0-.843.875Zm3.387-.875c.004 1.43 0 2.86.003 4.29a.887.887 0 0 0 .526.79c.17.081.363.08.546.077 2.017-.002 4.034.001 6.05-.002a.888.888 0 0 0 .859-.87c.002-1.43 0-2.858 0-4.287-2.661.001-5.322-.003-7.984.002Zm.002 10.473c-.003 1.804.004 3.608-.003 5.411 1.156.01 2.313.002 3.468.004 1.883-.003 3.767.006 5.65-.004-.007-1.803 0-3.607-.004-5.41a.888.888 0 0 0-.863-.873c-2.462-.002-4.924-.002-7.387 0a.887.887 0 0 0-.86.872Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M14.097 5.269a.532.532 0 0 1 .623.51c0 .573.002 1.146 0 1.719a.532.532 0 0 1-.501.51.532.532 0 0 1-.552-.507 236.48 236.48 0 0 1 0-1.726.532.532 0 0 1 .43-.506Z"
    />
  </svg>
);

export default IcCashierSave;
